<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="truck"/>
          {{ $t('logisticsCompany') }}
        </h1>
      </div>
    </div>
    <carrier-gateway-list v-if="tabIndex === 0"></carrier-gateway-list>
  </main>
</template>

<script>
import CarrierGatewayList from "@/views/order/CarrierGatewayList.vue";

export default {
  components: {CarrierGatewayList},
  data() {
    return {
      tabIndex: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        logisticsCompany: 'Logistics company',
      },
      vi: {
        logisticsCompany: 'Hãng vận chuyển',
      }
    }
  },
}
</script>